/**
 * Returns a new array with the same items in random order.
 *
 * Uses the Fisher–Yates shuffle, so each permutation is equally likely.
 * Does not mutate the input array.
 */
export function shuffleArray<T>(array: readonly T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
